import { jsx as _jsx } from "react/jsx-runtime";
import { Layout } from "@cinch-nx/landing-ui-shared";
import SignPost from "../../../assets/404.svg";
import { LandingFeatureErrorPage } from "../landing-feature-error-page";
export var ErrorBoundaryPage = function(param) {
    var errorTitle = param.errorTitle, errorText = param.errorText, homeCtaText = param.homeCtaText, searchCarsCtaText = param.searchCarsCtaText, currentUrl = param.currentUrl;
    return /*#__PURE__*/ _jsx(Layout, {
        children: /*#__PURE__*/ _jsx(LandingFeatureErrorPage, {
            title: errorTitle,
            subTitle: errorText,
            image: SignPost,
            hasCta: true,
            ctaText: homeCtaText,
            searchCarsCtaText: searchCarsCtaText,
            ctaHref: currentUrl
        })
    });
};
